import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';
import { isInIframe } from './env';

/**
 * 点击图片的拦截器，当在iframe中时，通过postMessage发送消息以便在父页面中调用图片查看器，否则使用cn-ui的图片查看器
 * @param {string} href
 */
export default function onClickImg(urls = [], current = 0) {
  if (!isInIframe) {
    const options = {
      dataSource: urls,
      index: current,
    };

    const pswp = new PhotoSwipe(options);
    pswp.init();
    return;
  }
  window.parent.postMessage(
    {
      source: 'ChatAI',
      action: 'previewImage',
      payload: {
        urls,
        current,
      },
    },
    '*',
  );
}
